var ezdia;
(function (ezdia) {
    var TYPE = 'contentHealthAnalysis';
    var DIALOG_WRAPPER_ID = 'ez-js-content-health-analysis-wrapper';
    var ERROR_DIALOG_WRAPPER_ID = 'ez-js-content-health-analysis-error-wrapper';
    var OPT_FORM = 'ez-js-prod-optimization-form';
    var colModel = [
        {
            name: 'add_product_type',
            label: 'Browse URL',
            editable: true,
            config: {
                options: {
                    by_category: 'By Category',
                    by_product_urls: 'By Product URLs'
                }
            }
        },
        {
            name: 'categoryUrl',
            label: 'Browse URL/Search URL',
            editable: true,
            edittype: 'url',
            placeholder: 'Enter a valid Walmart.com browse page URL',
            helperText: 'Eg. https://www.walmart.com/browse/pets/fish-tanks-aquariums-bowls/5440_202074_202101',
            config: {
                validate_rules: {
                    required: function () {
                        return validate('by_category');
                    }
                }
            }
        },
        {
            name: 'uploadFile',
            label: 'Upload file',
            editable: true,
            edittype: 'filetype',
            helperTextType: "<a target=\"_blank\" href=\"" + $.ezdia.config.pageParams.CONTEXT_ROOT + "/upload/CrewmachineContentHealthAnalysisTemplate.xlsx\">Download Template</a>",
            config: {
                disableByUrl: true,
                validation: {
                    itemLimit: 1,
                    allowedExtensions: ['xlsx', 'cvc']
                },
                validate_rules: {
                    required: function () {
                        return validate('by_product_urls');
                    }
                }
            }
        }
    ];
    var colModelOptimization = [
        {
            name: 'saved_order_id',
            label: 'Saved Order Id',
            edittype: 'hidden'
        },
        {
            name: 'order_id',
            label: 'Order Id',
            editable: true,
            edittype: 'text',
            config: {
                validate_rules: {
                    required: true
                }
            }
        },
        {
            name: 'due_date',
            label: 'Due Date',
            editable: true,
            edittype: 'date',
            config: {
                validate_rules: {
                    required: true
                }
            }
        },
        {
            name: 'priority',
            label: 'Priority',
            editable: true,
            edittype: 'radio',
            config: {
                options: {
                    p1: 'P1',
                    p2: 'P2',
                    p3: 'P3'
                },
                validate_rules: {
                    required: true
                }
            }
        }
    ];
    function handelAjaxAddProductSuccess(response) {
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        wrapper.html(response.msg).dialog({
            modal: true,
            title: 'Add Products',
            width: 400,
            height: 200,
            buttons: [
                {
                    text: 'Close',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                        window.location.reload();
                    }
                },
                {
                    text: 'Add More Products',
                    click: function () {
                        $(this).dialog('close');
                        addProductsDialog();
                    }
                }
            ]
        });
    }
    function handelAjaxAddProductError(response) {
        var wrapper = ezdia.util.getWrapper(ERROR_DIALOG_WRAPPER_ID);
        wrapper.html(response.msg).dialog({
            modal: true,
            title: 'Add Products',
            width: 400,
            height: 200,
            buttons: [
                {
                    text: 'Close',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ]
        });
    }
    function handelAjaxAddProduct(dialogInst) {
        var frm = $('#ez-js-add-product-form');
        if (!frm.valid()) {
            return;
        }
        var pageParams = $.ezdia.config.pageParams;
        var data = frm.serializeArray();
        var url = "" + frm.find('input[name=categoryUrl]').val();
        var searchParmas = new URLSearchParams(url);
        if (url.indexOf('/browse/') > -1) {
            data.push({
                name: 'categoryKey',
                value: '/browse/'
            });
            var facet = searchParmas.get('facet');
            if (facet) {
                data.push({
                    name: 'categoryQuery',
                    value: "" + facet
                });
            }
            else {
                data.push({
                    name: 'categoryQuery',
                    value: url.substring(url.indexOf('/browse/') + 8, 
                    // eslint-disable-next-line eqeqeq
                    url.indexOf('?') == -1 ? url.length : url.indexOf('?'))
                });
            }
        }
        else if (url.indexOf('/search/') > -1) {
            data.push({
                name: 'categoryKey',
                value: '/search/'
            });
            var facet = searchParmas.get('facet');
            var query = searchParmas.get('query');
            if (facet) {
                data.push({
                    name: 'categoryQuery',
                    value: facet + "&query=" + query
                });
            }
            else if (query) {
                data.push({
                    name: 'categoryQuery',
                    value: query
                });
            }
        }
        data.push({
            name: 'accountName',
            value: pageParams.account || pageParams.optReqAccount
        });
        $.ajax({
            type: 'POST',
            url: 'merchantCrawlRequest.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    dialogInst.dialog('close');
                    handelAjaxAddProductSuccess(response);
                }
                else {
                    handelAjaxAddProductError(response);
                }
            }
        });
    }
    function createWidget() {
        var uploadObject = {};
        $.ezdia.upload.init(uploadObject, {
            column: colModel[2]
        });
        $.ezdia.upload.create(uploadObject);
    }
    function validate(value) {
        var checked = $('#ez-js-add-product-form').find("#add_product_type_" + value + ":checked");
        return checked.length;
    }
    function addProductsDialog(btn) {
        if (btn) {
            $.ezdia.config.pageParams.optReqAccount = $(btn).data('account');
        }
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        var template = ezdia.templates.contentHealthAnalysis.formContent(colModel);
        wrapper.html(template).dialog({
            modal: true,
            title: 'Add Products',
            width: 600,
            height: 450,
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Submit',
                    class: 'btn-primary',
                    click: function () {
                        handelAjaxAddProduct($(this));
                    }
                }
            ]
        });
        $.ezdia.validate.all(colModel, 'ez-js-add-product-form');
        createWidget();
        $('#ez-js-nav-add-product-tabs').on('click', '[type="radio"]', function click() {
            $(this).tab('show');
        });
    }
    function handelAjaxSendForOptimizationSuccess(response, $elem) {
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        $elem.replaceWith('Sent');
        wrapper.html(response.msg).dialog({
            modal: true,
            title: 'Success',
            width: 400,
            height: 200,
            buttons: [
                {
                    text: 'Close',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                        window.location.reload();
                    }
                }
            ]
        });
    }
    function handelAjaxSendForOptimizationError(response) {
        // eslint-disable-next-line no-console
        console.log(response);
    }
    function handelAjaxSendForOptimization(dialogInst, $elem) {
        var frm = $("#" + OPT_FORM);
        if (!frm.valid()) {
            return;
        }
        var _a = $.ezdia.config, account = _a.account, optReqAccount = _a.optReqAccount;
        var data = frm.serializeArray();
        data.push({
            name: 'accountName',
            value: account || optReqAccount
        });
        $.ajax({
            type: 'POST',
            url: 'sendItemsForOptimization.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    dialogInst.dialog('close');
                    handelAjaxSendForOptimizationSuccess(response, $elem);
                }
                else {
                    handelAjaxSendForOptimizationError(response);
                }
            }
        });
    }
    function sendForProdOptimization(element) {
        var $elem = $(element);
        var orderId = $elem.closest('tr').find('td:first').text();
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        var template = ezdia.templates.contentHealthAnalysis.optimizationFormContent(colModelOptimization);
        wrapper.html(template).dialog({
            modal: true,
            title: 'Send for Optimization',
            width: 500,
            height: 350,
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Send',
                    class: 'btn-primary',
                    click: function () {
                        handelAjaxSendForOptimization($(this), $elem);
                    }
                }
            ]
        });
        var frm = $("#" + OPT_FORM);
        frm.find('[name="saved_order_id"]').val(orderId);
        frm.find('[name="order_id"]').val(orderId);
        $.ezdia.validate.all(colModelOptimization, OPT_FORM);
        $.ezdia.widgets.renderAll(colModelOptimization, TYPE);
    }
    function showContentHealthReport(element, response) {
        var $elem = $(element);
        var orderId = $elem.closest('tr').find('td')[1].innerText;
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        var template = $.ezdia.template.get('content-health-report', {
            'partial-content-search': 'content-chart-search'
        });
        response.queryFieldsJson[0].value = orderId;
        template = template(response);
        wrapper.html(template).dialog({
            modal: true,
            title: 'Send for Optimization',
            width: 900,
            height: 'auto',
            buttons: [
                {
                    text: 'Preview Email Here',
                    class: 'btn-link ez-brand-selection',
                    id: 'preview-email',
                    click: function () {
                        openPreviewPage();
                    }
                }
            ],
            open: function () {
                $('#preview-email').attr('disabled', 'disabled');
            }
        });
        response.queryFieldsJson.forEach(function (column) {
            var elem = column;
            elem.edittype = elem.type;
            elem.editable = true;
            $("[name=" + elem.name + "]").change(function (e) {
                var batchFieldname = $('#content_health_popup_search').find('input.content-health-form-control[name]')[0].name;
                var brandFieldID = $('#content_health_popup_search').find('select')[0]
                    .id;
                if (elem.name === batchFieldname) {
                    $("#" + brandFieldID).val('');
                }
                $.ezdia.contentHealthEmailObj.search(e);
            });
        });
        $.ezdia.widgets.renderAll(response.queryFieldsJson);
    }
    function shareWithBrand() {
        var form = $('#ez-form-send-email');
        if (!form.valid()) {
            return;
        }
        var wrapper = ezdia.util.getWrapper('ez-confirm-mail');
        var template = '<p>Are you sure you want to send the Content Health Report to the provided email address?</p><p>Once confirmed, the report will be sent via email.</p>';
        var formData = $('#content_health_popup_search').serializeArray();
        var filterFormData = {};
        var emailID = $('#ez-form-email-field').val();
        formData.forEach(function (parameter) {
            var existing = filterFormData[parameter.name];
            if (existing) {
                filterFormData[parameter.name].push(parameter.value);
            }
            else {
                filterFormData[parameter.name] = [parameter.value];
            }
        });
        var fieldID = $('#content_health_popup_search').find('select')[0].id;
        var brandValues = filterFormData[fieldID];
        filterFormData[fieldID] = [];
        filterFormData[fieldID][0] = brandValues;
        filterFormData = "" + $.param(filterFormData, true);
        wrapper.html(template).dialog({
            modal: true,
            title: 'Confirm Email',
            width: 600,
            height: 'auto',
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Send',
                    class: 'btn-primary',
                    click: function () {
                        sendEmail(filterFormData, emailID, $(this));
                    }
                }
            ]
        });
    }
    function sendEmail(filterFormData, emailID, $parentPopUp) {
        var options = $.ezdia.config.pageParams;
        var obj = $.data(document, 'ez.contentHealthConfig');
        $.ajax({
            type: 'POST',
            url: "shareContentHealthReport.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + obj.config.queryName + "&email=" + emailID,
            data: filterFormData,
            dataType: 'json',
            success: function (response) {
                var msg;
                if (response.success === 'true') {
                    msg = 'Email sent successfully!';
                    var validator = $('#ez-form-send-email').validate();
                    validator.resetForm();
                }
                else {
                    msg = 'Something went wrong. Please try again.';
                }
                $('#statusMsg').html(msg);
                $('#statusMsg').dialog({
                    modal: true,
                    title: 'Email status',
                    buttons: {
                        Ok: function () {
                            $(this).dialog('close');
                            $parentPopUp.dialog('close');
                        }
                    }
                });
            }
        });
    }
    function openPreviewPage() {
        var options = $.ezdia.config.pageParams;
        var obj = $.data(document, 'ez.contentHealthConfig');
        var formData = $('#content_health_popup_search').serializeArray();
        var filterFormData = {};
        formData.forEach(function (parameter) {
            var existing = filterFormData[parameter.name];
            if (existing) {
                filterFormData[parameter.name].push(parameter.value);
            }
            else {
                filterFormData[parameter.name] = [parameter.value];
            }
        });
        var fieldID = $('#content_health_popup_search').find('select')[0].id;
        var brandValues = filterFormData[fieldID];
        filterFormData[fieldID] = [];
        filterFormData[fieldID][0] = brandValues;
        filterFormData = "" + $.param(filterFormData, true);
        $.ajax({
            type: 'POST',
            url: "contentHealthEmailPreview.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + obj.config.queryName,
            data: filterFormData,
            dataType: 'json',
            success: function (response) {
                if (response.success === 'true') {
                    window.open(response.response);
                }
            }
        });
    }
    var widgets;
    (function (widgets) {
        widgets.contentHealthAnalysis = {
            addProductsDialog: addProductsDialog,
            sendForProdOptimization: sendForProdOptimization,
            showContentHealthReport: showContentHealthReport,
            openPreviewPage: openPreviewPage,
            shareWithBrand: shareWithBrand
        };
    })(widgets = ezdia.widgets || (ezdia.widgets = {}));
})(ezdia || (ezdia = {}));
